import React from 'react';
import { renderPCCEvent } from './shared/renderers';

/**
 * PCCEventBlock — rendu PARTAGÉ avec l'éditeur intranet (shared/renderers).
 * Badge de type coloré, tags, inscription. Les notes pastorales ne s'affichent
 * QUE dans l'éditeur (puck.isEditing) — jamais dans l'app (et l'API publique
 * les retire déjà de la charge utile).
 */
export default function PCCEventBlock({ props = {}, theme }) {
  return renderPCCEvent(props, theme);
}
